import React from 'react'
import Helmet from 'react-helmet'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import "../../styles/neoCalender.css"
export default class NeoCalendar extends React.Component {
  static defaultProps = {
    numberOfMonths: 1,
  }

  constructor(props) {
    super(props)
    this.handleDayClick = this.handleDayClick.bind(this)
    this.handleResetClick = this.handleResetClick.bind(this)
    this.state = this.getInitialState()
  }

  getInitialState() {
    return {
      from: undefined,
      to: undefined,
    }
  }

  handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state)
    this.props.setFromDate(range.from)
    this.props.setToDate(range.to)
    this.setState(range)
  }

  handleResetClick() {
    this.setState(this.getInitialState())
  }

  render() {
    const { from, to } = this.state
    const modifiers = { start: from, end: to }
    return (
      <div className='RangeExample'>
        {/* <p>
          {!from && !to && 'Please select the first day.'}
          {from && !to && 'Please select the last day.'}
          {from &&
            to &&
            `Selected from ${from.toLocaleDateString()} to
                ${to.toLocaleDateString()}`}{' '}
        </p> */}
        <DayPicker
          className='Selectable'
          numberOfMonths={this.props.numberOfMonths}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
          onDayClick={this.handleDayClick}
          disabledDays={{
            after: new Date(),
          }}
        />
        <Helmet>
          <style>
            {`
            .DayPicker-Caption > div {
              color: #171D35;
              font-size: 18px;
              font-weight: bold;            
            }
            .DayPicker-Weekday {
              color: #171D35;
              font-size: 9px;
              font-weight: bold;
            }
            .DayPicker-Day--disabled {
              cursor: default;
              pointer-events: none;//this will disable mouse event
            }
          `}
          </style>
        </Helmet>
      </div>
    )
  }
}
